<section id="how-it-works" class="section section-gradient-brand how-it-works-section">
  <div class="container">
    <h2 class="section-title">How It Works</h2>
    <p class="section-subtitle">Migrating your enterprise to KOTHA is a streamlined, hassle-free process handled entirely by our experts.</p>
    
    <div class="process-grid">
      <div class="process-step glass-card reveal-scale delay-100">
        <div class="step-number">01</div>
        <div class="step-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
        </div>
        <h3 class="step-title">Requirements</h3>
        <p class="step-desc">Share your business communication needs and current infrastructure setup with our team.</p>
      </div>

      <div class="process-step glass-card reveal-scale delay-200">
        <div class="step-number">02</div>
        <div class="step-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>
        </div>
        <h3 class="step-title">Design</h3>
        <p class="step-desc">We architect a custom IP Telephony solution tailored to scale with your organization.</p>
      </div>

      <div class="process-step glass-card reveal-scale delay-300">
        <div class="step-number">03</div>
        <div class="step-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
        </div>
        <h3 class="step-title">Deploy</h3>
        <p class="step-desc">Our engineers deploy the hardware and software with zero downtime to your business.</p>
      </div>
    </div>
  </div>
</section>
